import { NgxImageZoomModule } from 'ngx-image-zoom';
import { NgxImageCompressService } from 'ngx-image-compress';
import { SharedModule } from 'src/app/shared/shared.module';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgModule } from '@angular/core';

import { AttachDocumentsComponent } from './component/attach-documents/attach-documents.component';
import { ClaimDocsComponent } from './component/claim-docs/claim-docs.component';
import { ClaimMoviesComponent } from './component/claim-movies/claim-movies.component';
import { ClaimMovies2Component } from './component/claim-movies2/claim-movies2.component';
import { ClaimPhotosComponent } from './component/claim-photos/claim-photos.component';
import { ClaimPhotos2Component } from './component/claim-photos2/claim-photos2.component';
import { DocumentInfoDescriptionComponent } from './component/document-info-description/document-info-description.component';
import { ExportDocumentBoxComponent } from './component/export-document-box/export-document-box.component';
import { ExportDocumentListComponent } from './component/export-document-list/export-document-list.component';
import { ExportDocumentSelectComponent } from './component/export-document-select/export-document-select.component';
import { LinkInfoBoxComponent } from './component/link-info-box/link-info-box.component';
import { ManageProofDocumentComponent } from './component/manage-proof-document/manage-proof-document.component';
import { ProofDocsComponent } from './component/proof-docs/proof-docs.component';
import { ProofDocumentFormComponent } from './component/proof-document-form/proof-document-form.component';
import { ProofDocumentsMultiselectComponent } from './component/proof-documents-multiselect/proof-documents-multiselect.component';
import { SentDocsComponent } from './component/sent-docs/sent-docs.component';
import { SetClaimDocumentationDataComponent } from './component/set-claim-documentation-data/set-claim-documentation-data.component';
import { ShowDocumentContentComponent } from './component/show-document-content/show-document-content.component';
import { ShowDocumentComponent } from './component/show-document/show-document.component';
import { ShowDocumentsMultipleComponent } from './component/show-documents-multiple/show-documents-multiple.component';
import { ShowDocumentsMultiple2Component } from './component/show-documents-multiple2/show-documents-multiple2.component';
import { ShowProofLinkedDocsComponent } from './component/show-proof-linked-docs/show-proof-linked-docs.component';
import { UploadFilesComponent } from './component/upload-files/upload-files.component';
import { AudanetIntegrationModule } from '../audanet-integration/audanet-integration.module';
import { EntityDocsComponent } from './component/entity-docs/entity-docs.component';
import { ClaimDocumentsSelectComponent } from './component/claim-documents-select/claim-documents-select.component';
import { ChangePhotosTypeDialogComponent } from './component/change-photos-type-dialog/change-photos-type-dialog.component';
import { AddCustomerSignatureComponent } from './component/add-customer-signature/add-customer-signature.component';
import { SignatureInputDialogComponent } from './component/signature-input-dialog/signature-input-dialog.component';
import { SetUploadedDocumentDescriptionComponent } from './component/set-uploaded-document-description/set-uploaded-document-description.component';
import { AttachmentsButtonComponent } from './component/attachments-button/attachments-button.component';
import { ShowLinkedDocsComponent } from './component/show-linked-docs/show-linked-docs.component';
import { SearchSharedClaimDocumentLinksComponent } from './component/search-shared-claim-document-links/search-shared-claim-document-links.component';
import { SharedClaimDocumentLinkFormComponent } from './component/shared-claim-document-link-form/shared-claim-document-link-form.component';
import { SharedClaimDocumentLinkManageComponent } from './component/shared-claim-document-link-manage/shared-claim-document-link-manage.component';

const sharedComponents = 
[
  ClaimDocsComponent,
  ProofDocsComponent,
  SentDocsComponent,
  ClaimPhotosComponent,
  SetClaimDocumentationDataComponent,
  ShowProofLinkedDocsComponent,
  ManageProofDocumentComponent,
  UploadFilesComponent,
  ShowDocumentsMultipleComponent,
  ShowDocumentComponent,
  ProofDocumentFormComponent,
  ProofDocumentsMultiselectComponent,
  ShowDocumentContentComponent,
  AttachDocumentsComponent,
  ExportDocumentSelectComponent,
  ExportDocumentBoxComponent, 
  ExportDocumentListComponent,
  ClaimMoviesComponent,
  UploadFilesComponent,
  ClaimPhotos2Component,
  ClaimMovies2Component,
  DocumentInfoDescriptionComponent,
  ShowDocumentsMultiple2Component,
  LinkInfoBoxComponent,
  EntityDocsComponent,
  ClaimDocumentsSelectComponent,
  ChangePhotosTypeDialogComponent,
  AddCustomerSignatureComponent,
  SignatureInputDialogComponent,
  SetUploadedDocumentDescriptionComponent,
  AttachmentsButtonComponent,
  ShowLinkedDocsComponent,
  SearchSharedClaimDocumentLinksComponent
]

@NgModule({
  declarations: [
    sharedComponents,
    SharedClaimDocumentLinkFormComponent,
    SharedClaimDocumentLinkManageComponent,
  ],
  imports: [
    SharedModule,
    NgxImageZoomModule,
    ClipboardModule,
    AudanetIntegrationModule
  ],
  exports: [
    sharedComponents,
    ExportDocumentListComponent
  ],
  providers: [
    NgxImageCompressService
  ]
})
export class DocumentsModule { }
